module.exports = __webpack_public_path__ + "fonts/3ed9575.ttf";